/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The notification types an Internal (operator) user can receive, exported to the frontend by TypeGen.
 */
export class NotificationInternalTypeKeys {
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.InvoiceBatchFailed}
     */
    static readonly invoice_batch_failed: string = 'invoice_batch_failed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.DynamicExportFailed}
     */
    static readonly dynamic_export_failed: string = 'dynamic_export_failed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.DynamicExportSucceeded}
     */
    static readonly dynamic_export_succeeded: string = 'dynamic_export_succeeded';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ExternalAppSecretExpiry}
     */
    static readonly external_app_secret_expiry: string = 'external_app_secret_expiry';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.RequisitionReceivedOperator}
     */
    static readonly requisition_received_operator: string = 'requisition_received_operator';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.AttachmentUploadFailed}
     */
    static readonly attachment_upload_failed: string = 'attachment_upload_failed';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.EmailNotDelivered}
     */
    static readonly email_not_delivered: string = 'email_not_delivered';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveReady}
     */
    static readonly archive_ready: string = 'archive_ready';
    /**
     * {@inheritDoc F:Synqo.Cloud.Messages.Model.Api.NotificationTypeKeys.ArchiveFailed}
     */
    static readonly archive_failed: string = 'archive_failed';
}
